import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/common/Button';

const MobileNumberChanged = ({ returnToHome = () => {}, close = () => {} }) => {
  const goToHome = () => {
    close();
    returnToHome();
  };
  return (
    <div className="modal">
      <div className="modal__icon">
        <i className="modal__icon--check material-icon material-icon--check" />
      </div>
      <h2 className="modal__header">Your mobile number has been changed</h2>
      <p className="modal__paragraph">
        For security reasons a SMS confirming this number change will be sent to both phone numbers.
      </p>
      <Button className="modal__button" onClick={goToHome}>Return to Home</Button>
    </div>
  );
};

MobileNumberChanged.propTypes = {
  returnToHome: PropTypes.func,
  close: PropTypes.func
};

export default MobileNumberChanged;
